import view from './view';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next'
import * as mapActionsToProps from './actions';

const mapStateToProps = (state) => ({
  ...state
});

export default withTranslation()(connect(mapStateToProps, mapActionsToProps)(view));